class Video {
  constructor(file, id, uploaded = false) {
    this.file = file;
    this.id = id;
    this.objectUrl = null; 
    this.uploaded = uploaded;
  }

  getFile() {
    return this.file;
  }

  getId() {
    return this.id;
  }

  getVideoObjectUrl() {
    if (!this.objectUrl) {
      try {
        this.objectUrl = URL.createObjectURL(this.file);
      } catch (error) {
        console.error('Failed to create object URL:', error);
        return null;
      }
    }
    return this.objectUrl;
  }

  getVideoName() {
    return this.file.name;
  }

  getFileSize() {
    return this.file.size;
  }

  getFileSizeFormatted() {
    const size = this.file.size;
    if (size < 1024) return `${size} B`;
    if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} KB`;
    return `${(size / (1024 * 1024)).toFixed(1)} MB`;
  }

  getMimeType() {
    return this.file.type;
  }

  cleanup() {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  }

  isValid() {
    const extension = this.file.name.split('.').pop();
    return this.file && 
           this.file.size > 0 && 
           this.file.type && 
           (this.file.type.startsWith('video/') || 
            ['mp4', 'mov'].includes(extension && extension.toLowerCase()));
  }
}

export {Video}